//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, PayrollOverrideType } from './Enums';

export class TestEventCategoryInputItem extends ItemBase {
    Name: string | null = null;
    Color: EventColorEnum | null = null;
    PayrollOverride: PayrollOverrideType | null = null;
    PayrollOverrideAmount: number | null = null;
    EmailReminderHours: number | null = null;
    SMSReminderHours: number | null = null;

    constructor(initializer?: Partial<TestEventCategoryInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestEventCategoryInputItem";
}
